import { render, staticRenderFns } from "./RDMDestinationSelector.vue?vue&type=template&id=011a3f4e"
import script from "./RDMDestinationSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RDMDestinationSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports